import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Assessment, AssessmentSearch } from 'src/app/models/assessment';
import { AssessmentService } from 'src/app/services/assessment.service';
import { Ward } from '../ward-manage/ward';
import { WardService } from 'src/app/services/ward.service';
import { FormControl, FormGroup } from '@angular/forms';
import { UnionDomain } from 'src/app/services/union.domain';
import { SubdomainService } from 'src/app/services/subdomain.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-up-card-print',
  templateUrl: './up-card-print.component.html',
  styleUrls: ['./up-card-print.component.scss'],
})
export class UpCardPrintComponent {
  $subscriptions: Subscription[] = [];
  assessmentList: Assessment[] = [];
  assesmentId!: number;
  upCardBanner!: string;
  wardList: Ward[] = [];
  assessmentSearchForm!: FormGroup;

  constructor(
    private assessmentService: AssessmentService,
    private route: ActivatedRoute,
    private wardService: WardService,
    private toastr: ToastrService,
    public unionDomain: UnionDomain,
    private subdomainService: SubdomainService
  ) {}

  async ngOnInit(): Promise<void> {
    this.assesmentId = this.route.snapshot.queryParams['id'];
    this.upCardBanner =
      environment.apiBaseUrl +
      '/public/images/' +
      this.subdomainService.getSubdomain() +
      'UpSmartCard.bmp';
    this.getAssessmentList();
    await this.getWards();
    this.initializeForm();
  }
  private initializeForm = (formData?: AssessmentSearch) => {
    this.assessmentSearchForm = new FormGroup({
      ward_number: new FormControl(
        formData?.ward_number ? formData.ward_number : '0'
      ),
      holding_number: new FormControl(
        formData?.holding_number ? formData.holding_number : ''
      ),
      serial_no_start: new FormControl(
        formData?.serial_no_start ? formData.serial_no_start : '1'
      ),
      serial_no_end: new FormControl(
        formData?.serial_no_end ? formData.serial_no_end : '10000000'
      ),
    });
  };
  ngOnDestroy(): void {
    this.$subscriptions.forEach((s) => s.unsubscribe());
  }

  private getWards = async (): Promise<void> => {
    this.$subscriptions.push(
      this.wardService.getWardList().subscribe({
        next: (res: any) => {
          this.wardList = res;
        },
      })
    );
  };
  onSubmit = (): void => {
    console.log(this.assessmentSearchForm);
    this.$subscriptions.push(
      this.assessmentService
        .getFilteredAssessmentList(this.assessmentSearchForm.value, false)
        .subscribe({
          next: (res) => {
            this.assessmentList = res.data;
            this.toastr.success(res.message);
          },
          error: (err) => {
            this.toastr.error(err.error.message);
          },
        })
    );
  };
  private getAssessmentList = (): void => {
    if (this.assesmentId && this.assessmentService.sharedAssesment) {
      this.$subscriptions.push(
        this.assessmentService.getSingleAssesment(this.assesmentId).subscribe({
          next: (res) => {
            this.assessmentList.push(res);
          },
        })
      );
    } else {
      this.$subscriptions.push(
        this.assessmentService.getAssessmentList(false).subscribe({
          next: (res) => {
            this.assessmentList = res.data;
          },
        })
      );
    }
  };
}
